var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIDisease05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6083 5.99609H27.914C29.4333 5.99609 30.6655 7.22831 30.6655 8.74766C30.6655 13.3085 26.9689 17.0052 22.408 17.0052H18.6055V5.99609H18.6083Z",
    fill: "#E15757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5883 17.0052L19.6312 13.1524C18.9594 11.831 18.6081 10.3674 18.6081 8.88148V5.99609H11.2734C5.78416 5.99609 1.33203 10.4482 1.33203 15.9374V22.932C1.33203 24.9644 2.98242 26.612 5.01473 26.6064C6.45881 26.6036 7.7663 25.7561 8.3601 24.4375C8.73367 23.6067 9.50032 23.024 10.4008 22.8874L13.4423 22.4275C16.8295 21.9145 19.8124 19.9296 21.591 17.0024L21.5883 17.0052Z",
    fill: "#EA7070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56969 20.3855C7.33952 20.3855 7.96359 19.7614 7.96359 18.9916C7.96359 18.2217 7.33952 17.5977 6.56969 17.5977C5.79985 17.5977 5.17578 18.2217 5.17578 18.9916C5.17578 19.7614 5.79985 20.3855 6.56969 20.3855Z",
    fill: "#F09797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.332 18.6641C16.4366 18.6641 17.332 17.7686 17.332 16.6641C17.332 15.5595 16.4366 14.6641 15.332 14.6641C14.2275 14.6641 13.332 15.5595 13.332 16.6641C13.332 17.7686 14.2275 18.6641 15.332 18.6641Z",
    fill: "#F09797"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33073 14.6654C10.8035 14.6654 11.9974 13.4715 11.9974 11.9987C11.9974 10.5259 10.8035 9.33203 9.33073 9.33203C7.85797 9.33203 6.66406 10.5259 6.66406 11.9987C6.66406 13.4715 7.85797 14.6654 9.33073 14.6654Z",
    fill: "#DC5050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDisease05);
export default __webpack_public_path__ + "static/media/i_disease_05.10e34591a2255a9e718a1e64ac21a6d9.svg";
export { ForwardRef as ReactComponent };